import { IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import { DbMetadataFieldInfos } from "../../../../Core/Api/Types/db-metadata-field-infos";
import { CloseOutlined, ContentCopyOutlined } from "@mui/icons-material";
import ValueSetter from "./value-setter";
import { RuleToken } from "./commons";
interface TokenBuidlerProps {
  token: RuleToken;
  onChange: (e: any, tokenIndex: number, field: string, ruleIndex: number, nrIndex: number) => void;
  metadataFields: DbMetadataFieldInfos[];
  tokenIndex: number;
  ruleIndex: number;
  nrIndex: number;
  onDeleteToken: (nrIndex: number, ruleIndex: number, tokenIndex: number) => void;
  onCopyToken: (nrIndex: number, ruleIndex: number, tokenIndex: number) => void;
}
const TokenBuidler: React.FC<TokenBuidlerProps> = ({
  token,
  metadataFields,
  onChange,
  tokenIndex,
  ruleIndex,
  nrIndex,
  onDeleteToken,
  onCopyToken,
}) => {
  return (
    <Stack width={"100%"} alignItems={"center"} direction={"row"}>
      {token.type === "condition" ? (
        <Stack width={"100%"} alignItems={"center"} direction={"row"}>
          <Stack alignItems={"center"} direction={"row"}>
            <IconButton size="small" onClick={() => onDeleteToken(nrIndex, ruleIndex, tokenIndex)}>
              <CloseOutlined color="error" />
            </IconButton>
            <IconButton size="small" onClick={() => onCopyToken(nrIndex, ruleIndex, tokenIndex)}>
              <ContentCopyOutlined color="primary" />
            </IconButton>
          </Stack>
          <Stack alignItems={"center"} direction={"row"} flexWrap={"wrap"}>
            <ValueSetter
              ruleIndex={ruleIndex}
              tokenIndex={tokenIndex}
              field="testMeta"
              value={token.testMeta ?? ""}
              onChange={onChange}
              metadataFields={metadataFields}
              nrIndex={nrIndex}
            />
            <Typography textAlign={"center"} width={40} color={"text.tier"}>
              ==
            </Typography>
            <ValueSetter
              ruleIndex={ruleIndex}
              tokenIndex={tokenIndex}
              field="checkValue"
              value={token.checkValue ?? ""}
              onChange={onChange}
              metadataFields={metadataFields}
              nrIndex={nrIndex}
            />
            {token.testMeta2 !== undefined && (
              <Typography textAlign={"center"} width={40} color={"text.tier"}>
                &&
              </Typography>
            )}
            {token.testMeta2 !== undefined && (
              <ValueSetter
                ruleIndex={ruleIndex}
                tokenIndex={tokenIndex}
                field="testMeta2"
                value={token.testMeta2 ?? ""}
                onChange={onChange}
                metadataFields={metadataFields}
                nrIndex={nrIndex}
              />
            )}
            {token.testMeta2 !== undefined && (
              <Typography textAlign={"center"} width={40} color={"text.tier"}>
                ==
              </Typography>
            )}
            {token.testMeta2 !== undefined && (
              <ValueSetter
                ruleIndex={ruleIndex}
                tokenIndex={tokenIndex}
                field="checkValue2"
                value={token.checkValue2 ?? ""}
                onChange={onChange}
                metadataFields={metadataFields}
                nrIndex={nrIndex}
              />
            )}
            <Typography textAlign={"center"} width={40} color={"text.tier"}>
              ?
            </Typography>
            <ValueSetter
              ruleIndex={ruleIndex}
              tokenIndex={tokenIndex}
              field="valueIfTrue"
              value={token.valueIfTrue ?? ""}
              onChange={onChange}
              metadataFields={metadataFields}
              nrIndex={nrIndex}
            />
            <Typography textAlign={"center"} width={40} color={"text.tier"}>
              :
            </Typography>
            <ValueSetter
              ruleIndex={ruleIndex}
              tokenIndex={tokenIndex}
              field="valueIfFalse"
              value={token.valueIfFalse ?? ""}
              onChange={onChange}
              metadataFields={metadataFields}
              nrIndex={nrIndex}
            />
          </Stack>
        </Stack>
      ) : (
        <Stack alignItems={"center"} width={"100%"} direction={"row"}>
          <Stack direction={"row"}>
            <IconButton size="small" onClick={() => onDeleteToken(nrIndex, ruleIndex, tokenIndex)}>
              <CloseOutlined color="error" />
            </IconButton>
            <IconButton size="small" onClick={() => onCopyToken(nrIndex, ruleIndex, tokenIndex)}>
              <ContentCopyOutlined color="primary" />
            </IconButton>
          </Stack>
          <ValueSetter
            ruleIndex={ruleIndex}
            tokenIndex={tokenIndex}
            field="value"
            value={token.value ?? ""}
            onChange={onChange}
            metadataFields={metadataFields}
            nrIndex={nrIndex}
          />
        </Stack>
      )}
    </Stack>
  );
};

export default TokenBuidler;
